import { User } from '@legacy-types';

import { api } from '@shared/api/api';

export const getUsers = api.createIndex<User>('users');
